import { metricValueToNumber } from '../formatters'
import type { AffiliateLinkMetrics } from '../types/affiliate-link-metrics.types'
import type { Money } from '../types/common.types'

export type AffiliateLinkViewMode = 'admin' | 'advertiser'

export type AffiliateLinkKpis = {
  roas: number | null
  ers: number | null
  avgCostPerClick: Money | null
}

const divide = (
  numerator: Parameters<typeof metricValueToNumber>[0],
  denominator: Parameters<typeof metricValueToNumber>[0],
): number | null => {
  const num = metricValueToNumber(numerator)
  const den = metricValueToNumber(denominator)
  if (num == null || den == null || den === 0) {
    return null
  }
  return num / den
}

export const deriveAffiliateLinkKpis = (
  metrics: AffiliateLinkMetrics | null | undefined,
  viewMode: AffiliateLinkViewMode,
): AffiliateLinkKpis => {
  if (!metrics) {
    return { roas: null, ers: null, avgCostPerClick: null }
  }

  const estimatedCost =
    viewMode === 'admin' ? metrics.costCreatorEstimated : metrics.revenueInvoiceEstimated

  const roas =
    viewMode === 'admin'
      ? divide(metrics.orderValue, estimatedCost)
      : (metrics.advertiserRoas ?? null)
  const ers =
    viewMode === 'admin'
      ? divide(estimatedCost, metrics.orderValue)
      : (metrics.advertiserErs ?? null)

  const estimatedCostAmount = metricValueToNumber(estimatedCost)
  const avgCostPerClick =
    estimatedCostAmount != null && metrics.clicks > 0 && estimatedCost
      ? { amount: estimatedCostAmount / metrics.clicks, currency: estimatedCost.currency }
      : null

  return { roas, ers, avgCostPerClick }
}
